import React from "react";

function OrderIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.8907 27.61L29.4427 23.058C29.964 22.5367 29.964 21.6927 29.4427 21.1727L27.328 19.058C26.8067 18.5367 25.9627 18.5367 25.4427 19.058L20.8907 23.61C20.64 23.8607 20.5 24.1993 20.5 24.5527V28.0007H23.948C24.3013 28.0007 24.64 27.8607 24.8907 27.61V27.61Z"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83398 18.6667H15.1673"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.83398 11.9997H20.5007"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.8333 13.333V9.33301C25.8333 7.12367 24.0427 5.33301 21.8333 5.33301H8.5C6.29067 5.33301 4.5 7.12367 4.5 9.33301V21.333C4.5 23.5423 6.29067 25.333 8.5 25.333H15.1667"
        stroke="#EEEEEE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default OrderIcon;
